import projectConfig from 'common/config/project'
import { axios } from '../utils'
import { Content, ContentWithProducts } from '../types/entities/mongo/content'
import { fetchStoreNewsByNewsParam } from 'common/services/list'
import { NewsParam } from 'common/types/params'
import { ContentType, Sort, SpecialEventType, SubVertical } from 'common/constants'
import { getNewsPageSizeAtEvent, usingNewsAtEvent } from 'common/constants/event'

const defaultGalleryParams: NewsParam = {
  contentType: ContentType.NEWS,
  subVertical: SubVertical.ART,
  page: 1,
  pageSize: 10,
  sort: Sort.RECENT,
  hasImage: true,
}

const defaultForeignOutletNowParams: NewsParam = {
  contentType: ContentType.OUTLET_NOW,
  subVertical: SubVertical.FOREIGN,
  page: 1,
  pageSize: 10,
  sort: Sort.RECENT,
}

const defaultTraditionalAlcoholParams: NewsParam = {
  contentType: ContentType.FOOD_NEWS,
  subVertical: SubVertical.TRADITIONAL_ALCOHOL,
  page: 1,
  pageSize: 9,
  sort: Sort.RECENT,
  showRelatedProducts: true,
}

export const getDefaultContentParamAtEvent = (
  subVertical: SubVertical,
  specialEventType?: SpecialEventType,
): NewsParam => {
  if (!usingNewsAtEvent(subVertical, specialEventType)) return null

  const defaultParam = {
    subVertical,
    page: 1,
    pageSize: getNewsPageSizeAtEvent(subVertical, specialEventType),
  }

  let addParam = null
  switch (subVertical) {
    case SubVertical.ART:
      addParam = defaultGalleryParams
      break
    case SubVertical.TRADITIONAL_ALCOHOL:
      addParam = defaultTraditionalAlcoholParams
      break
    case SubVertical.FOREIGN:
      if (specialEventType && specialEventType === SpecialEventType.EXHIBITION) {
        addParam = defaultForeignOutletNowParams
      }
      break
  }

  return {
    ...defaultParam,
    ...addParam,
  }
}

export const fetchArtContents = async (param: NewsParam) => {
  return await fetchStoreNewsByNewsParam({
    ...defaultGalleryParams,
    ...param,
  })
}

export async function fetchContentDetail(newsId: string): Promise<Content> {
  const result = await axios.get<Content>(`/v1/contents/${newsId}`)
  return result && result.data
}

export async function fetchContentWithRelatedProduct(newsId: string): Promise<ContentWithProducts> {
  const result = await axios.get<ContentWithProducts>(`/v1/contents/${newsId}`, {
    params: { showRelatedProduct: true },
  })
  return result && result.data
}

export const fetchProductContents = async (id: string, productNo: string) => {
  const response = await axios.get(`/v1/products/${id}/contents/${productNo}/${projectConfig.project.toUpperCase()}`)
  return response && response.data
}

export const fetchLatestStoreNewsByProducts = async (productIds: string[]): Promise<Content[]> => {
  const response = await axios.get(`/v1/contents/latest-product-store-news`, { params: { productIds } })
  return response && response.data
}
